import { makeStyles } from "@mui/styles";
import { Paper } from "@mui/material";
import Main from "components/Main";
import Section from "components/Section";
import React from "react";
import { Outlet } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {},
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      paddingTop: theme.spacing(5),
    },
  },
  paperPadding: {
    padding: theme.spacing(3, 3),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(5, 3),
    },
  },
  sectionNoPaddingTop: {
    paddingTop: 0,
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  return (
    <Main>
      <Section className={classes.pagePaddingTop}>
        <Paper elevation={3} className={classes.paperPadding}>
          <Outlet />
        </Paper>
      </Section>
    </Main>
  );
};

export default Dashboard;
